
import React from 'react'
import { FRONT_END_NAME } from './constants';

class Loader  extends React.Component{

    componentDidMount() {
        
        this.timer = setTimeout(this.countDown, 240000);
    }
    countDown = () =>{
        
            window.location = FRONT_END_NAME;
          
    }
     componentWillUnmount() {
        
      clearTimeout(this.timer);
    }
    render() {
    return(
      <div className="loading" id="loader" style={{display:'block'}}>Loading&#8230;</div>
      
    
    )}
    
}

export default Loader;